<template>
  <div class="bind_other">

    <div class="title">
      <img src="@/assets/img/profile/disanfang.png" alt="">
      <span>第三方绑定</span>
    </div>

    <div class="content_list">

      <div @click="bindBtn(1)" class="content_item">
        <img width="50px" height="50px" src="@/assets/img/profile/wx.png" alt="">
        <span>微信号</span>
        <a v-if="!this.otherBindFlag.wx" :href="wxUrl">— 未绑定，请点击绑定 —</a>
        <a v-if="this.otherBindFlag.wx">— 已绑定微信号 —</a>
      </div>

      <div @click="bindBtn(2)" class="content_item">
        <img width="50px" height="50px" src="@/assets/img/profile/qq.png" alt="">
        <span>QQ号</span>
        <a v-if="!this.otherBindFlag.qq" :href="qqUrl">— 未绑定，请点击绑定 —</a>
        <a v-if="this.otherBindFlag.qq">— 已绑定QQ号 —</a>
      </div>

      <div @click="bindBtn(3)" class="content_item">
        <img width="50px" height="50px" src="@/assets/img/profile/dd.png" alt="">
        <span>钉钉号</span>
        <a v-if="!this.otherBindFlag.dingding" :href="ddUrl">— 未绑定，请点击绑定 —</a>
        <a v-if="this.otherBindFlag.dingding">— 已绑定钉钉号 —</a>
      </div>

    </div>

  </div>
</template>

<script>
import {
  getUserMsg,
  getWxCode,
  getDdCode,
  getQqCode
} from "@/network/loginRequest/api";

import utils from "@/util/index";

export default {
  name: "BindOther",
  data() {
    return {
      ddUrl: null,
      wxUrl: null,
      qqUrl: null,
      otherBindFlag: {
        wx: false,
        qq: false,
        dingding: false
      }
    };
  },
  created() {
    //判断是否绑定第三方
    this.isBind();

    //微信1/qq2/钉钉3
    getWxCode().then(res => {
      if (res.status == 200) {
        this.wxUrl = res.data.url;
      }
    });

    getQqCode().then(res => {
      if (res.status == 200) {
        this.qqUrl = res.data.url;
      }
    });

    getDdCode().then(res => {
      if (res.status == 200) {
        this.ddUrl = res.data.url;
      }
    });
  },

  methods: {
    isBind() {
      this.$set(
        this.otherBindFlag,
        "wx",
        this.$store.state.user.wx ? true : false
      );
      this.$set(
        this.otherBindFlag,
        "qq",
        this.$store.state.user.qq ? true : false
      );
      this.$set(
        this.otherBindFlag,
        "dingding",
        this.$store.state.user.dingding ? true : false
      );
    },

    bindBtn(type) {
      if (type == 1) {
        utils.setSess("wxBind", "1");
      }
      if (type == 2) {
        utils.setSess("qqBind", "2");
      }
      if (type == 3) {
        utils.setSess("ddBind", "3");
      }
    }
  }
};
</script>

<style lang='less' scoped>
.title {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  span {
    font-size: 16px;
    margin-left: 8px;
  }
}

.content_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333;
  position: relative;

  .content_item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;

    span:nth-child(2) {
      margin: 20px 0;
    }

    a {
      cursor: pointer;
      color: #24ba58;
      word-wrap: normal;
      text-decoration: none;
    }
  }
}
</style>